export default {
	"c79c05d3fa3206a781b597ac1444c875": "商城確認訂單頁_支付方式點擊",
	"134ea29c551500ad9cb61d1998a125a1": "商城（地址後置）",
	"83a380521708e07e9bd1776d35b90a5e": "商城收銀台頁_下單按鈕",
	"3b9321997185c98f5f1949e10eb79f92": "商城訂單確認頁_優惠券挽留彈窗_確認按鈕",
	"1edb72db12e4a8d95025f03206e30904": "收下並使用",
	"a0ac001e96c907b65b5728aafb159a9c": "商城確認訂單頁_優惠券點擊",
	"b4cc0ca6f230d4533072b4b589515a94": "《用户購買協議》",
	"77174ec07d6a6ff24d2a46498447cae7": "無可用代金券",
	"9671f62d29868f3b1002ef0a17586993": "請選擇可用代金券",
	"d4dbfb3307f9c03f3991713bc17c67b5": "商城訂單確認頁_優惠券點擊",
	"9b235059c79512ff2ce38754c6cd1f2a": "放棄"
}
